

import React from 'react'

import Style from './Navbar.module.css';

import { useDisclosure } from '@chakra-ui/react';

import { useState } from 'react';

import { HStack, Box, Text, Image, Button, IconButton, Link as ChakraLink } from '@chakra-ui/react'


import { Link as ScrollLink, animateScroll as scroll } from "react-scroll";

import { NavLink as RouterLink, Router } from 'react-router-dom'

import { NavDrawer } from './NavDrawer';
import { HamburgerIcon } from '@chakra-ui/icons'

import { useRef } from 'react';
import { useContext } from 'react';
import { ColorContext } from '../Context/ColorContext';



const Navbar_options = [{ text: 'Home', id: 'home', class: 'nav-link home' }, { text: 'About', id: 'about', class: 'nav-link about' }, { text: 'Skills', id: 'skills', class: 'nav-link skills' }, { text: 'Projects', id: 'projects', class: 'nav-link projects' }, { text: 'Contact', id: 'contact', class: "nav-link contact" }];


const Navbar = () => {

  const { isOpen, onOpen, onClose } = useDisclosure();

  const { current } = useRef([]);
  const {colors,setColors,underLineColor} = useContext(ColorContext)


  const Active_Link = (e, index) => {


    current.forEach((el, i) => {

      if (index === i) {

        el.classList.add(underLineColor);

      } else {

        el.classList.remove(underLineColor);

      }

    })


  }


  const OpenPDF = () => {

    const url = `https://drive.google.com/file/d/126nip9sVVPZDBt2c2yXcxlDXK0e6Pevf/view?usp=share_link`

    window.open(url, '_blank');



  }




let a = "<BHARAT />"


  return (

    <Box zIndex={'3'} minW='280px' mb='20px' boxShadow={`1px 1px 1px  ${colors}`} position={'sticky'} top='0' bg={colors} color='white' as='nav' id="nav-menu" p='2'>

      <HStack m='auto' w={{ base: '95%', '587px': '90%', '1120px': '80%' }} justify='space-between'>

        <IconButton size={['sm', 'md']} mr='5px' display={{ base: 'block', '836px': 'none' }} _hover={{ background: colors }} bg={colors} onClick={onOpen} variant='none' icon={<HamburgerIcon />}></IconButton>

        {/* <Image _hover={{ cursor: 'pointer' }} w='150px' src='tejasLogo.png'></Image> */}
        {<Text fontSize={"25px"} fontWeight={"600"}>{a}</Text>}



        <HStack display={{ base: 'none', '836px': 'flex' }} w={{ 'base': '450px', '966px': '500px' }} justify='space-between'>

          {Navbar_options.map((el, i) => {


            return <ScrollLink className={el.class} key={Math.random()} to={el.id} smooth={true} duration={300}>

              <Text className={i === 0 ? underLineColor : ''} ref={(el) => current[i] = el} onClick={(e) => Active_Link(e, i)} _hover={{ cursor: 'pointer', color: 'black', borderBottom: '2px solid', borderColor: 'black' }} px='2' py='1' fontWeight={600}>{el.text}</Text>


            </ScrollLink>



          })}

        </HStack>


        <Button onClick={OpenPDF} id="resume-button-1" _hover={{ background: 'rgb(115, 249, 200);' }} className="nav-link resume" size={['sm', 'md']} variant='none' bg='white;'   color='black'><ChakraLink id="resume-link-1" isExternal href='Bharat-sharma-resume.pdf' download="Bharat-sharma-resume.pdf" _hover={{ textDecoration: 'none' }}>Resume</ChakraLink></Button>



      </HStack>




      <NavDrawer isOpen={isOpen} onOpen={onOpen} onClose={onClose} />





    </Box>

  )
}

export default Navbar